<template>
  <div>
    <PCNavbar selectIndex="3" pageType="service" :currentIndex="currentIndex" />
    <!-- <MobileNavBar :currentActive="1" /> -->
     <ServerPage @section-change="handleSectionChange" />
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
// import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import ServerPage from '@/components/serverPage/index.vue'
export default {
  components: {
    PCNavbar,
    // MobileNavBar
    ServerPage
  },
  data() {
    return {
      currentIndex: 0
    }
  },
  methods: {
    handleSectionChange(index) {
      this.currentIndex = index
    }
  }
}
</script>

<style>
</style>